import { devLogos } from "src/app/mq/configs/logos.config";

export const environment = {
    production: false,
  //  baseurl: 'http://127.0.0.1:5000',
   // baseurl: 'https://cpat-dev-819517096465.us-central1.run.app/',
    baseurl: 'https://sql-generator-90052637893.us-central1.run.app',
    firebaseConfig: {
      apiKey: "AIzaSyD9fe5piGZuH-6MvT-M3CW43PSGJQiEvCM",
      authDomain: "mpro-e5e4e.firebaseapp.com",
      projectId: "mpro-e5e4e",
      storageBucket: "mpro-e5e4e.appspot.com",
      messagingSenderId: "851203138877",
      appId: "1:851203138877:web:1dc399666f4ecbf2311154",
      measurementId: "G-F78H66T9JJ",
    },
    logos:devLogos
  };